
import { ReactNode } from 'react';
import { interpolateSafe, interpolateWithReactStrategySafe, PhraseMap } from '@ms/yammer-i18n';

export default class InterpolateStrings {

  public static feature: string = 'error';

  private locale: string;
  private phrases: PhraseMap;

  constructor(locale: string, phrases: PhraseMap) {
    this.locale = locale;
    this.phrases = phrases;
  }

  public adalThirdPartyCookieError(): string {
    return interpolateSafe(this.locale, this.phrases, 'adalThirdPartyCookieError');
  }

  public adalThirdPartyCookieErrorModalTitle(): string {
    return interpolateSafe(this.locale, this.phrases, 'adalThirdPartyCookieErrorModalTitle');
  }

  public adalThirdPartyCookieErrorReauthenticateButtonText(): string {
    return interpolateSafe(this.locale, this.phrases, 'adalThirdPartyCookieErrorReauthenticateButtonText');
  }

  public attachmentErrorCannotRender(): string {
    return interpolateSafe(this.locale, this.phrases, 'attachmentErrorCannotRender');
  }

  public failedToLoadMessage(): string {
    return interpolateSafe(this.locale, this.phrases, 'failedToLoadMessage');
  }

  public failedToLoadCallToAction(args: { link: (str: string) => ReactNode }): ReactNode {
    return interpolateWithReactStrategySafe(this.locale, this.phrases, 'failedToLoadCallToAction', args);
  }

  public feedErrorCannotRender(): string {
    return interpolateSafe(this.locale, this.phrases, 'feedErrorCannotRender');
  }

  public flightsErrorCannotRender(): string {
    return interpolateSafe(this.locale, this.phrases, 'flightsErrorCannotRender');
  }

  public groupHeaderActionsErrorCannotRender(): string {
    return interpolateSafe(this.locale, this.phrases, 'groupHeaderActionsErrorCannotRender');
  }

  public inboxThreadErrorCannotRender(args: { link: (str: string) => ReactNode }): ReactNode {
    return interpolateWithReactStrategySafe(this.locale, this.phrases, 'inboxThreadErrorCannotRender', args);
  }

  public messageErrorCannotRender(): string {
    return interpolateSafe(this.locale, this.phrases, 'messageErrorCannotRender');
  }

  public messageVersionsErrorCannotRender(): string {
    return interpolateSafe(this.locale, this.phrases, 'messageVersionsErrorCannotRender');
  }

  public momentsListErrorCannotRender(): string {
    return interpolateSafe(this.locale, this.phrases, 'momentsListErrorCannotRender');
  }

  public momentsModalErrorCannotRender(): string {
    return interpolateSafe(this.locale, this.phrases, 'momentsModalErrorCannotRender');
  }

  public networkSwitcherErrorCannotRender(): string {
    return interpolateSafe(this.locale, this.phrases, 'networkSwitcherErrorCannotRender');
  }

  public notificationsErrorCannotRender(): string {
    return interpolateSafe(this.locale, this.phrases, 'notificationsErrorCannotRender');
  }

  public publisherErrorCannotRender(): string {
    return interpolateSafe(this.locale, this.phrases, 'publisherErrorCannotRender');
  }

  public searchResultErrorCannotRender(): string {
    return interpolateSafe(this.locale, this.phrases, 'searchResultErrorCannotRender');
  }

  public searchResultsListErrorCannotRender(): string {
    return interpolateSafe(this.locale, this.phrases, 'searchResultsListErrorCannotRender');
  }

  public sharedMessageErrorCannotRender(): string {
    return interpolateSafe(this.locale, this.phrases, 'sharedMessageErrorCannotRender');
  }

  public thirdPartyCookiesDisabledFirstLine(): string {
    return interpolateSafe(this.locale, this.phrases, 'thirdPartyCookiesDisabledFirstLine');
  }

  public thirdPartyCookiesDisabledSecondLine(args: { link: (str: string) => ReactNode }): ReactNode {
    return interpolateWithReactStrategySafe(this.locale, this.phrases, 'thirdPartyCookiesDisabledSecondLine', args);
  }

}
